export default __webpack_public_path__ + "static/media/banner-2.5f10b07b.jpg";